import applied from "../Assets/Images/360/Applied.jpg";
import soratha from "../Assets/Images/360/Soratha_Pilimaya.jpg";
import basha from "../Assets/Images/360/basha.jpg";
import gateTwo from "../Assets/Images/360/gateTwo.jpg";
import court from "../Assets/Images/360/court.jpg";
import Geo from "../Assets/Images/360/Geo.jpg";
import sumangala from "../Assets/Images/360/Sumangala_Piliruwa.jpg";
import garden_1 from "../Assets/Images/360/garden_1.jpg";
import garden_2 from "../Assets/Images/360/garden_2.jpg";
import garden_road from "../Assets/Images/360/garden_road.jpg";
import main_road from "../Assets/Images/360/main_road.jpg";
import main_garden from "../Assets/Images/360/main_garden.jpg";
import secondGateGarden from "../Assets/Images/360/secondGateGarden.jpg";
import FMG from "../Assets/Images/360/FMG.jpg";
import road from "../Assets/Images/360/road.jpg";
import main_road_1 from "../Assets/Images/360/main_road_1.jpg";
import area_1 from "../Assets/Images/360/area_1.jpg";
import area_2 from "../Assets/Images/360/area_2.jpg";
import area_3 from "../Assets/Images/360/area_3.jpg";
import near_forestry from "../Assets/Images/360/near_forestry.jpg";
import close from "../Assets/Images/close.png";

const Images = {
  applied,
  soratha,
  sumangala,
  basha,
  gateTwo,
  court,
  Geo,
  FMG,
  road,
  garden_1,
  garden_2,
  garden_road,
  main_road,
  main_garden,
  main_road_1,
  secondGateGarden,
  area_1,
  area_2,
  area_3,
  near_forestry,
  close
};

export default Images;
